<script lang="ts">
  import OutDateAlert from './partials/OutDateAlert.svelte';
  import ProfileMergeList from '$shared/molecules/ProfileMergeList/ProfileMergeList.svelte';
  import Label from '$provider/constants/Label';
  import EmptyMergeList from './partials/EmptyMergeList.svelte';
  import type { ProfileMergeListResultOption } from '$shared/components/types';
  import AtlasMergePrepStatusAlert from './partials/AtlasMergePrepStatusAlert.svelte';
  import type { AtlasMergePrepStatusModel } from '$provider/models/profile/merge/AtlasMergePrepStatusModel';
  import AtlasMergePrepStatus from '$provider/lib/apis/models/AtlasMergePrepStatus';

  const DefaultMergeRecordDesc = `Review and confirm the following records to complete this merge. If a record is not
        reviewed, this information will replace the existing record by default.`;
  const DetaultNewRecordDesc = `These will be created when you complete this merge.`;

  interface Props {
    showAlert?: boolean;
    isEmpty?: boolean;
    option: ProfileMergeListResultOption;
    atlasMergePrepStatus: AtlasMergePrepStatusModel;
    importId: string;
    onevent?: (name: string) => void;
    onclose?: () => void;
    onalert?: (payload: any) => void;
    onreview?: (payload: any) => void;
    ontoggleadd?: (payload: any) => void;
    onresolveedit?: (payload: any) => void;
    onclickrecord?: (payload: any) => void;
    onaddall?: (payload: any) => void;
    onignoreall?: (payload: any) => void;
  }

  let {
    showAlert = false,
    isEmpty = false,
    option,
    atlasMergePrepStatus,
    importId,
    onevent,
    onclose,
    onalert,
    onreview,
    ontoggleadd,
    onresolveedit,
    onclickrecord,
    onaddall,
    onignoreall
  }: Props = $props();

  const onAlertClick = (id: string): void => {
    onevent?.(id);
  };

  const onClickClose = (): void => {
    onclose?.();
  };

  let showAtlasSteps =
    $derived(atlasMergePrepStatus &&
    (atlasMergePrepStatus.status === AtlasMergePrepStatus.Completed ||
      atlasMergePrepStatus.status === AtlasMergePrepStatus.Failed) &&
    atlasMergePrepStatus.importId === importId);
</script>

<div class="result-container">
  {#if showAlert}
    <div class="alert" data-cy="alert-data-out-of-date">
      <OutDateAlert onclick={() => onAlertClick('refresh')} />
    </div>
  {/if}
  {#if showAtlasSteps}
    <div class="alert">
      <AtlasMergePrepStatusAlert
        {atlasMergePrepStatus}
        onclick={() => onAlertClick('showAtlasState')}
      />
    </div>
  {/if}
  {#if !isEmpty}
    {@const isMergeSectionEmpty =
      option?.mergeSections.filter((section) => !section.isListEmpty).length === 0}
    {#if !isMergeSectionEmpty}
      <div data-cy="existing-records" class="exising-record">
        <ProfileMergeList
          list={option?.mergeSections}
          option={{
            title: Label.MergeExistingRecords,
            icon: 'icon-caqh-merge black',
            description: option?.mergeDesc || DefaultMergeRecordDesc
          }}
          {onalert}
          {onreview}
          {ontoggleadd}
        />
      </div>
    {/if}
    {@const isaddSectionEmpty =
      option?.addSections.filter((section) => !section.isListEmpty).length === 0}
    {#if !isaddSectionEmpty}
      <div data-cy="new-records" class="new-records">
        <ProfileMergeList
          list={option?.addSections}
          option={{
            title: Label.NewRecordsAdded,
            icon: 'icon-file-plus black',
            description: option?.addDesc || DetaultNewRecordDesc
          }}
          {onalert}
          {onreview}
          {ontoggleadd}
          {onresolveedit}
          {onclickrecord}
          {onaddall}
          {onignoreall}
        />
      </div>
    {/if}
  {:else}
    <EmptyMergeList label={option?.emptyDesc} onclick={onClickClose} />
  {/if}
</div>

<style>
  .exising-record,
  .new-records {
    margin-top: 32px;
  }
</style>
